import {
    CONFIRMED_GET_CONTENT,
    CONFIRMED_CREATE_CONTENT,
    CONFIRMED_DELETE_CONTENT,
    CONFIRMED_EDIT_CONTENT,
    CONFIRMED_SEND_CONTENT,
    FAILED_SEND_CONTENT,
  } from "../actions/ContentBankType"
  
  const initialState = {
    contentList: [],
    num_rows: 0,
    sentStatus: null,
    loading: false,
    error: null,

  }
  
  export default function ContentBankReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_CONTENT:
        return {
          ...state,
          // contentList: action.payload || [],
          contentList: action.payload.contentList || [],
          num_rows: action.payload.num_rows || 0,
          loading: false,
          error: null,
        }
  
      case CONFIRMED_DELETE_CONTENT:
        return {
          ...state,
          contentList: state.contentList.filter(
            (content) =>
              String(content.content_bank_id || content.content_id || content.id) !== String(action.payload.content_id),
          ),
          loading: false,
          error: null,
        }
        case CONFIRMED_CREATE_CONTENT:
            return {
              ...state,
              contentList: [
                ...state.contentList,
                {
                  ...action.payload,
                  content_id: action.payload.content_bank_id || action.payload.content_id,
                },
              ],
              loading: false,
              error: null,
            }
            case CONFIRMED_EDIT_CONTENT:
                return {
                  ...state,
                  contentList: state.contentList.map((content) =>
                    String(content.content_id) === String(action.payload.content_bank_id || action.payload.content_id)
                      ? {
                          ...action.payload,
                          content_id: action.payload.content_bank_id || action.payload.content_id,
                        }
                      : content,
                  ),
                  loading: false,
                  error: null,
                }
            case CONFIRMED_SEND_CONTENT:
                    return {
                      ...state,
                      sentStatus: { success: true, contentId: action.payload },
                    }
         case FAILED_SEND_CONTENT:
                    return {
                      ...state,
                      sentStatus: { success: false, error: action.payload },
                    }
      default:
        return state
    }
  }
  